module.exports = __webpack_public_path__ + "img/localadventures-payments-cop.68d8b62.svg";